import React from "react";
import {
  DEFAULT_QUESTION_TITLE,
  MATRIX_CONTENT_TYPE,
  numberChineseChange,
  RATING_QUESTION,
  QUESTION_TYPES
} from "@src/utils/constant";
import QuestionError from "@src/routes/weForm/components/Questions/QuestionError";
import { numberRegTest } from "@src/utils/valid";
import Constant from "@src/utils/constant";
import i18n from "@src/i18n";
import { BACK_END_DOMAIN } from '@src/configs/web.config'
import { replaceUrlDomain } from './domain-utils'

let trim = /^\s+|\s+$/g; // 去掉前后空格

// 获取url的参数值
export const queryString = param => {
  const reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)");
  const r =
    window.location.search.substr(1).match(reg) ||
    window.location.hash
      .substring(window.location.hash.search(/\?/) + 1)
      .match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return "";
};

export const isPc = !/(iPhone|iPad|iPod|iOS|Android)/i.test(
  window.navigator.userAgent
);

export const isVoidObject = data => {
  if (JSON.stringify(data) === "{}") {
    return true; // 如果为空,返回true
  }
  return false;
};

//  数组去重
export function unique(arr) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      if (arr[i] == arr[j]) {
        //第一个等同于第二个，splice方法删除第二个
        arr.splice(j, 1);
        j--;
      }
    }
  }
  return arr;
}

export function compareDate(date1, date2) {
  let oDate1 = new Date(date1);
  let oDate2 = new Date(date2);
  if (oDate1.getTime() > oDate2.getTime()) {
    return true; //第一个大
  } else {
    return false; //第二个大
  }
}

/**
 * 图片转base64
 * @param  url
 * @returns
 */
export const urlToBase64 = params => {
  const { url, width, height, content } = params || {};
  return new Promise((resolve, reject) => {
    let image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    if (url.includes("http")) {
      image.src = url + `?time=${new Date().getTime()}`;
    } else {
      image.src = url;
    }
    image.onload = () => {
      let canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      let context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, 200, 200);
      if (content) {
        context.textAlign = "center";
        context.font = "bold 12px Arial";
        context.fillStyle = "#666"; // 设置文字的填充颜色
        context.fillText(content, 100, 222);
      }
      let result = canvas.toDataURL("image/png");
      resolve(result);
    };
    image.onerror = () => {
      reject(new Error("图片地址错误"));
    };
  });
};

// 判断是否是pc
export const judgeIsMobile = () => {
  let phoneReg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
  if (window.navigator.userAgent.match(phoneReg)) {
    return true; // 移动端
  } else {
    return false; // PC端
  }
};

// 节流throttle代码（定时器）：
export const throttle = function(func, delay) {
  let timer = null;
  return function() {
    let context = this;
    let args = arguments;
    if (!timer) {
      timer = setTimeout(function() {
        func.apply(context, args);
        timer = null;
      }, delay);
    }
  };
};

// 当前环境是否为生产环境
export const isHuaweiCloud = () => {
  return window.location.host.includes("huaweicloud");
};

// 当前环境是否为生产环境
export const isICSLHuaweiCloud = () => {
  return window.location.host.includes("icsl");
};

// 题目标题的默认填充
export const setQusetionTitle = (item = {}) => {
  return item.questionTitle
    ? item.questionTitle
    : DEFAULT_QUESTION_TITLE[item.questionType];
};

// 选项内容的默认填充
export const setOptionContent = (optionContent, index) => {
  return optionContent
    ? optionContent
    : `${i18n.t("options")}${numberChineseChange[index]}`;
};
/*
  列内容的默认填充
  type   column 列  row  行
*/
export const setMatrixContent = (optionContent, index, type) => {
  if (type === MATRIX_CONTENT_TYPE.COLUNM) {
    return optionContent
      ? optionContent
      : `${i18n.t("column")}${numberChineseChange[index]}`;
  } else {
    return optionContent
      ? optionContent
      : `${i18n.t("row")}${numberChineseChange[index]}`;
  }
};

// 输入的字符是否符合数字规则
export const phoneReg = value => {
  return value.replace(/[^\d]/g, "");
};

// 判断是否合法的QQ
export const isQQ = str => {
  // 1 首位不能是0 ^[1-9]
  // 2 必须是 [5, 11] 位的数字 \d{4, 9}
  let reg = /^[1-9][0-9]{4,10}$/;
  if (reg.test(str.replace(trim, ""))) {
    return true;
  }
  return false;
};
// 检查字符串是否为合法Email地址
export const isEmail = str => {
  let reg = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
  if (str.trim().length > 255 || !str.trim().length) {
    return false;
  } else if (reg.test(str.trim())) {
    return true;
  }
  return false;
};
// 检查字符串是否为合法身份证号码
export const isIdentityId = str => {
  let reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  if (reg.test(str.replace(trim, ""))) {
    return true;
  }
  return false;
};
// 判断输入的是否是合法的电话号码
export const isTelpehone = str => {
  let fourTel = /^400\-[\d|\-]{7}[\d]{1}$/;
  let eightTel = /^800\-[\d|\-]{7}[\d]{1}$/;
  let isTel = /^(\d{3}-\d{8}|\d{4}-\d{7})$/;

  if (isTel.test(str.replace(trim, ""))) {
    return true;
  } else if (fourTel.test(str.replace(trim, ""))) {
    if (str.match(/[\-]/g) == "-,-") {
      return true;
    } else {
      return false;
    }
  } else if (eightTel.test(str.replace(trim, ""))) {
    if (str.match(/[\-]/g) == "-,-") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

// returnFillValue
export const returnFillValue = (ps, value) => {
  for (let i = 0; i < ps.length; i++) {
    if (ps[i].propertyKey === Constant.FILL_TYPE) {
      switch (ps[i].propertyValue) {
        case Constant.PHONE:
          // 手机正则校验
          value = phoneReg(value);
          break;
        case Constant.QQ_number:
          // QQ正则校验
          value = phoneReg(value);
          break;

        default:
          break;
      }
    }
  }
};

// 必填、正则、非必填校验
export const returnVerification = (answers, order, question) => {
  return (
    answers[order].showMeBug && (
      <>
        {question.isRequired ? (
          <>
            {/* 必填校验 */}
            {!answers[order].answerContent ? (
              <>
                <QuestionError title={i18n.t("isMust")} />
              </>
            ) : (
              <>
                {/* 正则校验 */}
                <QuestionError
                  title={numberRegTest(answers[order], question)}
                />
              </>
            )}
          </>
        ) : (
          <>
            {/* 非必填规则校验 */}
            {answers[order].answerContent && (
              <QuestionError title={numberRegTest(answers[order], question)} />
            )}
          </>
        )}
      </>
    )
  );
};

//  是否为微信设备
export const isWechat = () => {
  return /MicroMessenger/i.test(window.navigator.userAgent);
};

//是否为红Welink
export const isRedWelink = () => {
  return navigator.userAgent.indexOf("AnyOffice") != -1;
};

/**
 *  评分题分数设置value值兼容历史数据做下转换
 * @param question 每道题目
 * @returns {*} 对应的属性值
 */
export const resetRating = question => {
  if (
    !question &&
    question?.questionType !== "score" &&
    !question?.properties.length
  )
    return question;

  question.properties.map(_ => {
    if (_.propertyKey === "scoreNumber") {
      if (_.propertyValue === "十分制" || _.propertyValue == 10) {
        _.propertyValue = RATING_QUESTION.TEN_POINTS;
      } else if (_.propertyValue === "五分制" || _.propertyValue == 5) {
        _.propertyValue = RATING_QUESTION.FIVE_POINTS;
      }
    }
  });
};
export const isIphoneDingtalk = () => {
  let isDingtalk = /DingTalk/i.test(window.navigator.userAgent);
  let isIphone = /iPhone/i.test(window.navigator.userAgent);
  return isDingtalk && isIphone;
};

export const addFucsListenerScrollToTop = () => {
  const isiOS = /iPhone|iPad|iPod|iOS/.test(navigator.userAgent);
  if (isiOS) {
    let isFocusin = false;
    let pageBackNormFunc;
    // 聚焦后，键盘弹起
    document.body.addEventListener("focusin", () => {
      isFocusin = true;
      pageBackNormFunc && clearTimeout(pageBackNormFunc);
    });
    // 失焦后，键盘关闭
    document.body.addEventListener("focusout", () => {
      if (isFocusin) {
        // 页⾯滚动回原来的位置
        pageBackNormFunc = setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }, 200);
      }
      isFocusin = false;
    });
  }
};

// 获取一个随机的字符串
export const getRandomHashString = (length = 8) => {
  let str = "";
  for (let i = 0; i < length; i++) {
    let code = Math.ceil(Math.random() * 16).toString(16);
    str += code;
  }
  return str;
};
//跳题关联跳题到最后的问题
export const associatedJumpQuestion = (
  allQuestions,
  _editQuestions,
  questionId
) => {
  const conditionItem = allQuestions?.find(question => {
    return question.conditions.some(conditonItem => {
      return conditonItem.conditionQuestionId === questionId;
    });
  });
  if (conditionItem) {
    if (conditionItem.skips[0]?.skipToEnd) {
      //  过滤出被跳过的题,并恢复他们
      const SkippedList = allQuestions.filter(
        question => question.questionOrder > conditionItem.questionOrder
      );
      return [..._editQuestions, ...SkippedList];
    } else {
      return _editQuestions;
    }
  } else {
    return _editQuestions;
  }
};

// 判断当前浏览器类型
export const getBrowserType = () => {
  const explorer = window.navigator.userAgent;
  //判断是否为IE浏览器
  if (explorer.indexOf("MSIE") >= 0) {
    return "IE";
  }
  //判断是否为Firefox浏览器
  else if (explorer.indexOf("Firefox") >= 0) {
    return "Firefox";
  }
  //判断是否为Chrome浏览器
  else if (explorer.indexOf("Chrome") >= 0) {
    return "Chrome";
  }
  //判断是否为Opera浏览器
  else if (explorer.indexOf("Opera") >= 0) {
    return "Opera";
  }
  //判断是否为Safari浏览器
  else if (explorer.indexOf("Safari") >= 0) {
    return "Safari";
  }
};

/**
 * 判断是否为开发环境
 * @returns boolean
 */
export const isDevEnv = () => {
  const reg = /localhost/;
  return reg.test(window.location.hostname);
};

/**
 *
 * @param name 存储localStorage名
 * @param value 存储localStorage值
 * @param expires 过期时间,如果是七天后过期，(7 * 24 * 60 * 60)，单位是秒，可选, 不传表示不过期
 */
export const setLocalStorageWithExpire = (name, value, expires = 0) => {
  window.localStorage.removeItem(name);
  let currentTimeStamp = new Date().getTime();
  if (expires) {
    expires = currentTimeStamp + expires * 1000;
  }
  let obj = {
    name,
    value,
    expires
  };
  window.localStorage.setItem(obj.name, JSON.stringify(obj));
};

/**
 * @param name 存入的localStorage名，如果没有返回null
 */
export const getLocalStorageWithExpire = name => {
  let item = window.localStorage.getItem(name);
  if (!item) return null;
  try {
    item = JSON.parse(item);
  } catch (error) {}
  if (item.expires !== 0) {
    let now = new Date().getTime();
    //当前时间戳与存储的过期时间戳对比，如果大于就是过期了，如果小于或等于就还没过期
    if (now > item.expires) {
      //缓存过期，清除缓存，返回false
      window.localStorage.removeItem(name);
      return null;
    } else {
      //缓存未过期，返回值
      return item.value || item;
    }
  }
  return item.value || item;
};

// 删除缓存值
export const removeLocalStorageWithExpire = name => {
  window.localStorage.removeItem(name);
};

//JSON.parse方法，内部集成try-catch逻辑
export const safeParse = value => {
  try {
    return JSON.parse(value);
  } catch (err) {
    console.error(err);
  }
};

// 判断是否填写答案
export const isupdateAnswer = answers => {
  let newAnswers = _.cloneDeep(answers);
  // 过滤空数据
  newAnswers.forEach(item => {
    if (!item.answerContent && item.optionIds.length === 0 && item.isRequired) {
      item.requireSkip = true;
    }
  });
  newAnswers = newAnswers.filter(item => {
    //表格填空题answerContent是数组与其他题目类型answerContent类型不同，需要额外判断
    if (item.questionType !== QUESTION_TYPES.MATRIX_FILL) {
      return !(
        !item.answerContent &&
        item.optionIds.length === 0 &&
        !item.requireSkip
      );
    } else {
      return !(
        !item.answerContent.length &&
        item.optionIds.length === 0 &&
        !item.requireSkip
      );
    }
  });
  if (newAnswers.length === 0 || newAnswers.every(item => item.requireSkip)) {
    return false;
  }
  return true;
};

export const getRandom = () => {
  let seed = new Date().getTime();
  seed = (seed * 9301 + 49297) % 233280;

  return seed / 233280.0;
};

// 获取不同环境的logo地址
export const getLogoAddress = () => {
  const gammaIcon =
    `${BACK_END_DOMAIN}/appstore/file/static/20220506/6534f96d31234f5c86a7986c16556816.png`;
  const uatIcon =
    `${BACK_END_DOMAIN}/appstore/file/static/20220506/2ee9f4dd63014e6db90416b1508117f9.png`;
  const preIcon =
    `${BACK_END_DOMAIN}/appstore/file/static/20220506/c2606dcbfb3f47a791e6ddf80a0f66eb.png`;
  let iconUri = "";
  if (headerPath()?.includes?.("gamma")) {
    iconUri = gammaIcon;
  } else if (headerPath()?.includes?.("clouduat")) {
    iconUri = uatIcon;
  } else if (headerPath()?.includes?.("welink.huaweicloud")) {
    iconUri = preIcon;
  }
  return iconUri;
};

// 拼接url参数，支持path参数和query参数
export function spliceUrl(oldUrl, params) {
  if (!oldUrl) {
    console.error("url为空");
    return oldUrl;
  }
  let newUrl = oldUrl;
  let strParams = "";

  const keys = Object.keys(params);
  for (let index = 0; index < keys.length; index = index + 1) {
    const key = keys[index];
    if (params[key] !== undefined) {
      if (newUrl.indexOf(`{${key}}`) === -1) {
        strParams += `&${key}=${params[key]}`;
      } else {
        newUrl = newUrl.replace(`{${key}}`, `${params[key]}`);
      }
    }
  }

  if (newUrl.indexOf("?" === -1)) {
    strParams = `?${strParams.slice(1)}`;
  }
  newUrl += strParams;
  if (newUrl.search(/{.+}/) !== -1) {
    console.error("url参数错误", newUrl);
  }
  return newUrl;
}

export const isToday = time => {
  const oneDay = 24 * 60 * 60 * 1000;
  const now = new Date().getTime();
  const tempNow = Math.ceil(now / oneDay);
  const tempTime = Math.ceil(time / oneDay);

  return tempNow - tempTime === 0;
};

export const headerPath = () => {
  return process.env.HEADERPATH;
};
// 通过参数获取连接
export const getUrlByParam = (url, params, appendTime) => {
  let newUrl = url;
  if (typeof params === "object") {
    let paramUrl = "?";
    let keysArray = [];
    Object.keys(params).forEach(item => {
      keysArray.push(`${item}=${encodeURIComponent(params[item])}`);
    });
    newUrl = url + paramUrl + keysArray.join("&");
    if (appendTime) {
      newUrl += `&_t=${new Date().getTime()}`;
    }
  }
  return newUrl;
};

// 获取url的应用类型
export const APP_TYPE = {
  // 内部应用
  innerapp: "0",
  // 三方应用
  isv: "2"
};

// 获取应用请求类型对应路径
export const getAppPathFromType = type => {
  if (typeof type === "number") {
    type += "";
  }
  switch (type) {
    case APP_TYPE.innerapp:
      return "innerapp";
    case APP_TYPE.isv:
      return "isv";
    default:
      return "innerapp";
  }
};

// 接口请求的应用类型
export const getAppTypeFromPath = type => {
  switch (type) {
    case "innerapp":
      return APP_TYPE.innerapp;
    case "isv":
      return APP_TYPE.isv;
    default:
      return APP_TYPE.innerapp;
  }
};

export const urlDomainDeal = url => {
  return replaceUrlDomain(url);
};

export const replaceHtmlDomain = (html) => {
  if (!html || typeof html !== 'string') {
    return html;
  }
  const domainArr = window.location.host.split('.');
  const com = domainArr[domainArr.length-1]
  if (location.hostname.includes('gamma') || location.hostname.includes('clouduat')) {
    html = html.replace(/welink.huawei.com/g, `welink.huawei.${com}`);
    html = html.replace(/welink.huawei.cn/g, `welink.huawei.${com}`);
  } else {
    html = html.replace(/welink.huaweicloud.com/g, `welink.huaweicloud.${com}`);
    html = html.replace(/welink.huaweicloud.cn/g, `welink.huaweicloud.${com}`);
  }
  return html;
}

// 当前租户控制逻辑
export const hideControlByTenant = (tenantInfo) => {
  const userInfo = tenantInfo || {};
  // 时间控制器
  const getCurrentTimeSegment = () => {
    const now = new Date();
    const minutes = now.getMinutes();
    const hours = now.getHours();
    if (hours >= 12) {
      let timeSeg = 0;
      if (minutes < 15) {
        timeSeg = 1;
      } else if (minutes < 30) {
        timeSeg = 2;
      } else if (minutes < 45) {
        timeSeg = 3;
      } else {
        timeSeg = 4;
      }
      return timeSeg % 2 === 1;
    } else {
      return false;
    }
  };
  // 根据租户展示
  const testTenant = [
    '3D5015C397664D58B8AF883AB7A633E2', // 测试联营企业
    '2EF7A01FFD3A4EC094BA2BD7A92AA69F', // UAT基础we码
    '8906EA606B7C492DB7DCFD3E9E1DD8E5', // 亿家
    'F820E1A9F2C7407A956CDB1DCE0A5195', // 新AS测试0601
  ];
  // 根据时间控制器及租户展示
  const testTimeTenant = [];
  return testTenant.includes(userInfo.tenantId) || (getCurrentTimeSegment() && testTimeTenant.includes(userInfo.tenantId));
};

export const downloadFile = (url) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function() {
    if (xhr.status === 200) {
      const res = xhr.response;
      const link = document.createElement('a');
      link.style.display = 'none';
      const url = window.URL.createObjectURL(res);
      link.href = url;
      link.setAttribute('download', 'mockJson.json');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    } else {
      console.error('下载失败:', xhr.status);
    }
  };
  xhr.onerror = function() { console.error('下载请求出错'); };
  xhr.send();
}
